import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { FamilySchema } from '../..'

export const SearchSchema = z.object({
  // Entrée de sidebar dont dépend cette page : une zone CTA n'est atteignable que depuis « CTA > Calendrier ».
  family: FamilySchema.default('cta'),
})

export type Search = z.infer<typeof SearchSchema>

export const Route = createFileRoute('/_dashboard/site/$id/operation/scheduler/cta/$zoneCtaId/')({
  validateSearch: SearchSchema,
})
